import { JobDetailViewModel } from "./jobDetailTypes";

export const MOCK_TICKET_UUID = "a1b2c3d4-e5f6-7890-abcd-ef1234567890";

export const mockLogisticsTicketDetail: JobDetailViewModel = {
  ticketUuid: MOCK_TICKET_UUID,
  displayId: "PU-2026-187",
  companyName: "Sentinel Analytics",
  city: "Somerville",
  state: "MA",
  stage: "pending_confirmation",
  client: "Sentinel Analytics",
  location: "Somerville, MA",
  assets: 80,
  pallets: 4,
  pickupDate: "2024-06-19",
  assetSummary: "45 Mac, 23 PCs, 12 Monitors",
  siteNotes: "Loading dock available 9am-4pm. COI required.",
  customerContact: "Erik Sipple",
  customerContactEmail: "esipple@sentinelanalytics.com",
  receivedStatus: "Not received",
  pickupAttachments: [],
  coordinatorId: "15600",
  coordinatorName: "Aaron Hampton",
  destinationAddressId: null,
  destinationAddresses: [],
  destinationAddressLocked: false,
  vendors: [
    {
      id: "vendor-1",
      name: "Revivn NY",
      email: "marcus.rivera@revivn.com",
      vendorType: "Internal Fleet",
      priceLabel: "$0",
      priceInCents: 0,
      initial: "B",
      color: "#1E88E5",
    },
    {
      id: "vendor-2",
      name: "Prager",
      email: "hannah@prager.com",
      vendorType: "Freight",
      priceLabel: "$640",
      priceInCents: 64000,
      initial: "P",
      color: "#43A047",
    },
    {
      id: "vendor-3",
      name: "BTX Freight",
      email: "carl@btx.com",
      vendorType: "Freight",
      priceLabel: "$1,300",
      priceInCents: 130000,
      initial: "R",
      color: "#FB8C00",
    },
  ],
  currentAssignment: null,
  confirmation: null,
  pickupCompletion: null,
  deliveryVerification: null,
  daysFromToday: "In 7 days",
  daysSinceReceived: null,
  invoiceStatus: "pending",
  isComplete: false,
  nextStageLabel: "PENDING CONFIRMATION",
  previousStageLabel: null,
};
